/* eslint eqeqeq: 'off' */
import React, { Component } from "react";
import { connect } from "react-redux";
import "../../../../Assets/EnsembleStyles/EnsTenantServicesFeaturebar.css";
import { TabContent, TabPane, Nav, NavItem, NavLink } from "reactstrap";
import classnames from "classnames";
import TenantTable from "../../../EnsembleComponents/TenantComponents/ManageTenants/TenantTable";
import Invoices from "../ManageTenants/Invoices/Invoices";
import TemperatureAdjustment from "../ManageTenants/TemperatureAdjustments/TemperatureAdjustment";
// import Requests from '../ManageTenants/Requests/Requests';
import RequestsIndex from "../ManageTenants/Requests/Requests_Index";
import { IconButton, Tooltip } from "@mui/material";

//import ViewIndividualtenant from '../ManageTenants/Tenants/ViewTenant/ViewTenantTabSystem';
//import AddTenantEmployee from '../ManageTenants/_ModalsForms/AddTenantEmployee';
import Zones from "../ManageTenants/Zones/Zones";
import Holidays from "../ManageTenants/Holidays/Holidays";
import Brand from "../ManageTenants/Brand/Brand";
import { PlayIcon } from "components/EnsembleComponents/ReportsManagement/ManageReports";
import { setAmplitudeEvent } from "amplitude/amplitude";
const windowFeatures =
  "resizable=1,status=yes,scrollbars=0,toolbar=0,titlebar=0,location=no,width=800,height=650,dialog=1,minimizable=1";
const windowName = "EnsembleVideoWindow";
const videoUrl =
  "https://vimeo.com/718043707/6ae6e7fe2d?share=copy&childpage=true";

class Navigationheader extends Component {
  componentDidMount() {
    sessionStorage.setItem("WorkOrderSortingDetails", null);
    sessionStorage.setItem("PMSortingDetails", null);
    //ASU Sessions
    sessionStorage.setItem("ASUInvoiceTabFilter", null);
    sessionStorage.setItem("ASUMonthlyTabFilter", null);
    let StateVal =
      this.props.OnPremises !== undefined && this.props.OnPremises !== null
        ? this.props.OnPremises
        : false;
    this.setState({ OnPremisesState: StateVal });
  }

  componentWillReceiveProps(nextProps) {
    if (this.props != nextProps) {
      let StateVal =
        nextProps.OnPremises !== undefined && nextProps.OnPremises !== null
          ? nextProps.OnPremises
          : false;
      this.setState({ OnPremisesState: StateVal });
    }
  }

  constructor(props) {
    super(props);
    this.toggle = this.toggle.bind(this);
    this.state = {
      activeTab: "1",
      clicked: false,
      activeContent: "1",
      redirect: false,
      OnPremisesState: false,
    };
  }

  toggle(tab) {
    if (this.state.activeTab !== tab) {
      this.setState({
        activeTab: tab,
        activeContent: tab,
      });
    }
  }

  render(getLabels, OnPremises) {
    let label,
      staticContent,
      activeContent = null;

    label = this.props.getLabels;

    // staticContent
    staticContent = (
      <div>
        {this.state.OnPremisesState ? (
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
            }}
          >
            <span
              className="tab_title PageTitleBar"
              style={{
                paddingLeft: "12px",
                display: "inline-block",
                "margin-bottom": "15px",
              }}
            >
              {label["ManageTenants.TitleHeader.Text"]}
            </span>
            <Tooltip title="Introduction to Tenant Services">
              <IconButton
                id="tenantServiceVideoIconButton"
                style={{
                  textAlign: "right",
                  alignItems: "center",
                  margin: "20px 20px 0px 0px",
                }}
                onClick={() => {window.open(videoUrl, windowName, windowFeatures);
                  setAmplitudeEvent('Help Videos', {
                    "Source": "Icon",
                    "Video Name": "Introduction to Tenant Services",
                    "Page URL": '/React/Home.aspx?Page=tenant#/managetenant'})
      
                }}
              >
                <PlayIcon style={{ width: "25px", height: "25px" }} />
              </IconButton>
            </Tooltip>
          </div>
        ) : (
          ""
        )}
        <Nav tabs style={{ "border-bottom": "0px" }}>
          <NavItem>
            {" "}
            <NavLink
              className={classnames(
                { active: this.state.activeTab === "1" },
                "Tab_header_link",
                "link_cursor",
                "header_tab"
              )}
              onClick={() => {
                this.toggle("1");
              }}
            >
              {" "}
              {label["TabbedView.Tenants.Text"] !== undefined
                ? label["TabbedView.Tenants.Text"]
                : "Tenants"}{" "}
            </NavLink>{" "}
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames(
                { active: this.state.activeTab === "2" },
                "Tab_header_link",
                "link_cursor",
                "header_tab"
              )}
              onClick={() => {
                this.toggle("2");
              }}
            >
              {" "}
              {label["TabbedView.Invoices.Text"] !== undefined
                ? label["TabbedView.Invoices.Text"]
                : "Invoices"}
            </NavLink>{" "}
          </NavItem>
          <NavItem>
            <NavLink
              className={classnames(
                { active: this.state.activeTab === "3" },
                "Tab_header_link",
                "link_cursor",
                "header_tab"
              )}
              onClick={() => {
                this.toggle("3");
              }}
            >
              {" "}
              {label["TabbedView.Requests.Text"] !== undefined
                ? label["TabbedView.Requests.Text"]
                : "Requests"}{" "}
            </NavLink>{" "}
          </NavItem>
          <NavItem>
            {" "}
            <NavLink
              className={classnames(
                { active: this.state.activeTab === "4" },
                "Tab_header_link",
                "link_cursor",
                "header_tab"
              )}
              onClick={() => {
                this.toggle("4");
              }}
            >
              {" "}
              {label["TabbedView.TemperatureAdjustment.Text"] !== undefined
                ? label["TabbedView.TemperatureAdjustment.Text"]
                : "TemperatureAdjustment"}{" "}
            </NavLink>{" "}
          </NavItem>
          <NavItem>
            {" "}
            <NavLink
              className={classnames(
                { active: this.state.activeTab === "5" },
                "Tab_header_link",
                "link_cursor",
                "header_tab"
              )}
              onClick={() => {
                this.toggle("5");
              }}
            >
              {" "}
              {label["TabbedView.Holidays.Text"] !== undefined
                ? label["TabbedView.Holidays.Text"]
                : "Holidays"}
            </NavLink>{" "}
          </NavItem>
          <NavItem>
            {" "}
            <NavLink
              className={classnames(
                { active: this.state.activeTab === "6" },
                "Tab_header_link",
                "link_cursor",
                "header_tab"
              )}
              onClick={() => {
                this.toggle("6");
              }}
            >
              {" "}
              {label["TabbedView.Zones.Text"] !== undefined
                ? label["TabbedView.Zones.Text"]
                : "Zones"}{" "}
            </NavLink>{" "}
          </NavItem>
          <NavItem>
            {" "}
            <NavLink
              className={classnames(
                { active: this.state.activeTab === "7" },
                "Tab_header_link",
                "link_cursor",
                "header_tab"
              )}
              onClick={() => {
                this.toggle("7");
              }}
            >
              {" "}
              {label["TabbedView.Brand.Text"] !== undefined
                ? label["TabbedView.Brand.Text"]
                : "Brand"}{" "}
            </NavLink>{" "}
          </NavItem>
        </Nav>
      </div>
    );

    // activeContent

    if (this.state.activeContent == "1") {
      activeContent = (
        <div className="tenant_tab_border">
          <TabContent
            activeTab="1"
            className={
              this.state.OnPremisesState ? "OnPrimise_active_Content" : ""
            }
          >
            <TabPane tabId="1">
              {" "}
              <TenantTable />{" "}
            </TabPane>
          </TabContent>
        </div>
      );
    } else if (this.state.activeContent == "2") {
      activeContent = (
        <div className="tenant_tab_border">
          <TabContent
            activeTab="2"
            className={
              this.state.OnPremisesState ? "OnPrimise_active_Content" : ""
            }
          >
            <TabPane tabId="2">
              <Invoices />
            </TabPane>{" "}
            {/* Invoices tab */}
          </TabContent>
        </div>
      );
    } else if (this.state.activeContent == "3") {
      activeContent = (
        <div className="tenant_tab_border">
          <TabContent activeTab="3" className="Requests_active_Content">
            <TabPane tabId="3" className="tenant_content_border">
              <RequestsIndex />{" "}
            </TabPane>{" "}
            {/* Requests tab */}
          </TabContent>
        </div>
      );
    } else if (this.state.activeContent == "4") {
      activeContent = (
        <div className="tenant_tab_border">
          <TabContent
            activeTab="4"
            className={
              this.state.OnPremisesState ? "OnPrimise_active_Content" : ""
            }
          >
            <TabPane tabId="4">
              <TemperatureAdjustment />
            </TabPane>{" "}
            {/* Temperature Adjustment */}
          </TabContent>
        </div>
      );
    } else if (this.state.activeContent == "5") {
      activeContent = (
        <div className="tenant_tab_border">
          <TabContent
            activeTab="5"
            className={
              this.state.OnPremisesState ? "OnPrimise_active_Content" : ""
            }
          >
            <TabPane tabId="5">
              {" "}
              <Holidays />{" "}
            </TabPane>{" "}
            {/* Holidays */}
          </TabContent>
        </div>
      );
    } else if (this.state.activeContent == "6") {
      activeContent = (
        <div className="tenant_tab_border">
          <TabContent
            activeTab="6"
            className={
              this.state.OnPremisesState ? "OnPrimise_active_Content" : ""
            }
          >
            <TabPane tabId="6">
              <Zones />{" "}
            </TabPane>
          </TabContent>
        </div>
      );
    } else if (this.state.activeContent == "7") {
      activeContent = (
        <div className="tenant_tab_border">
          <TabContent
            activeTab="7"
            className={
              this.state.OnPremisesState ? "OnPrimise_active_Content" : ""
            }
          >
            <TabPane tabId="7">
              <Brand />{" "}
            </TabPane>
          </TabContent>
        </div>
      );
    }

    return (
      <div
        className={
          !this.state.OnPremisesState ? "tenant_content_scrollbar" : ""
        }
      >
        {staticContent}
        {activeContent}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    getLabels: state.CulturalLabelsRootReducer.LabelsBasedOnPreference,
    OnPremises: state.authService.IsOnPremise,
  };
};

export default connect(mapStateToProps, null)(Navigationheader);
